import { render, staticRenderFns } from "./BookingChanges.vue?vue&type=template&id=00705f64&"
import script from "./BookingChanges.vue?vue&type=script&lang=js&"
export * from "./BookingChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports